export default "__VITE_PUBLIC_ASSET__dba44f98__"